import { useHistory } from "react-router-dom";
import { Menu } from "semantic-ui-react";

const MobileUseHistoryMenuItem = ({ folder, focusFolderManager, goToAliquot, goToResult, goToTubes }) => {
	let history = useHistory();

	const goToFolderManager = (folderId) => {
		focusFolderManager([folderId]);
		if (goToResult) goToResult();
		if (goToAliquot) goToAliquot();
		if (goToTubes) goToTubes();
		history.push("/home/foldermanager");
	};

	return (
		<Menu.Item
			as="a"
			key={`folder-mob-${folder.id}`}
			onClick={(e) => {
				goToFolderManager(folder.id);
			}}
		>
			{folder.code}
		</Menu.Item>
	);
};
export default MobileUseHistoryMenuItem;
